<template>
  <populate-form
    v-if="popupAccountFormObj.action==='create'"
    :formTitle="'建立  '+popupAccountFormObj.store_name+'  店長帳號'"
    fkey="ma01"
    ref="merchantAccountQuickForm"
    populateOptionVar="createOptions"
    formDataObjVar="popupAccountFormObj"
    :validatePrompt="true"
    :parentVue="this"
    :keyEnterCB="createAdminAccount"
  ></populate-form>
  <populate-form
    v-else-if="popupAccountFormObj.action==='updpwd'"
    :formTitle="'重設  '+popupAccountFormObj.store_name+'店長('+popupAccountFormObj.account+'  )密碼'"
    fkey="ma02"
    ref="merchantAccountQuickForm2"
    populateOptionVar="updOptions"
    formDataObjVar="popupAccountFormObj"
    :validatePrompt="false"
    :parentVue="this"
  ></populate-form>
  <populate-form
    v-else-if="popupAccountFormObj.action==='updsubpwd'"
    :formTitle="'重設 '+popupAccountFormObj.account_name+'('+popupAccountFormObj.account+')的密碼'"
    fkey="ma03"
    ref="merchantAccountQuickForm3"
    populateOptionVar="updSubAccountOptions"
    formDataObjVar="popupAccountFormObj"
    :validatePrompt="false"
    :parentVue="this"
  ></populate-form>
</template>

<script>
import {
  apiUpdateStoreManageAccount
} from '@/api/AdminManage.js'

export default {
  name: 'AccountQuick',
  components: {

  },
  props: {
    'cbSave':{
      type:Function,
      default: function () {
        return
      }
    },
    'cbCancel':{
      type:Function,
      default: function () {
        return
      }
    },
    'parentVue':Object,
  },
  data: function () {
    return {
      createOptions: [
        {
          'componentType':'span',
          'akey':'span1',
          'col':6,
          'placeholder':'店長帳號',
        },
        {
          'componentType':'text',
          'akey':'account',
          'col':6,
          'placeholder':'請輸入店長帳號',
        },
        {
          'componentType':'span',
          'akey':'span2',
          'col':6,
          'placeholder':'店長姓名',
          'title':'店長帳號api未提供此時維護需事後至帳號管理編輯修改',
        },
        {
          'componentType':'text',
          'akey':'account_name',
          'col':6,
          'disabled':true,
          'placeholder':'輸入店長姓名',
        },
        {
          'componentType':'span',
          'akey':'span3',
          'col':6,
          'placeholder':'店長密碼',
        },
        {
          'componentType':'password',
          'akey':'password',
          'col':6,
          'placeholder':'輸入店長密碼',
        },
        {
          'componentType':'span',
          'akey':'span4',
          'col':6,
          'placeholder':'再輸入一次密碼',
        },
        {
          'componentType':'password',
          'akey':'password2',
          'col':6,
        },
        {
          'componentType':'b-button',
          'akey':'btnCancel',
          'col':6,
          'placeholder':'取消',
          'execCallback':this.cbCancel
        },
        {
          'componentType':'b-button',
          'akey':'btnSave',
          'col':6,
          'placeholder':'更新',
          'execCallback':this.createAdminAccount,
          'waitClick':true,
        },
      ],
      updOptions: [
        {
          'componentType':'span',
          'akey':'span1',
          'col':6,
          'placeholder':'新密碼',
        },
        {
          'componentType':'password',
          'akey':'password',
          'col':6,
          'placeholder':'請輸入密碼',
        },
        {
          'componentType':'span',
          'akey':'span2',
          'col':6,
          'placeholder':'再輸入一次新密碼',
        },
        {
          'componentType':'password',
          'akey':'password2',
          'col':6,
          'placeholder':'再輸入一次密碼',
        },
        {
          'componentType':'b-button',
          'akey':'btnCancel',
          'col':6,
          'placeholder':'取消',
          'execCallback':this.cbCancel
        },
        {
          'componentType':'b-button',
          'akey':'btnSave',
          'col':6,
          'placeholder':'更新',
          'execCallback':this.resetAdminPwd,
          'waitClick':true,
        },
      ],
      // form元素都一樣,主要是更新的api不同
      updSubAccountOptions: [
        {
          'componentType':'span',
          'akey':'span1',
          'col':6,
          'placeholder':'新密碼',
        },
        {
          'componentType':'password',
          'akey':'password',
          'col':6,
          'placeholder':'請輸入密碼',
        },
        {
          'componentType':'span',
          'akey':'span2',
          'col':6,
          'placeholder':'再輸入一次新密碼',
        },
        {
          'componentType':'password',
          'akey':'password2',
          'col':6,
          'placeholder':'再輸入一次密碼',
        },
        {
          'componentType':'b-button',
          'akey':'btnCancel',
          'col':6,
          'placeholder':'取消',
          'execCallback':this.cbCancel
        },
        {
          'componentType':'b-button',
          'akey':'btnSave',
          'col':6,
          'placeholder':'更新',
          'execCallback':this.resetAccountPwd,
          'waitClick':true,
        },
      ],
    }
  },
  methods: {
    createAdminAccount (doneCB, evt) {
      if (!this.popupAccountFormObj['account']) {
        this.$refs.merchantAccountQuickForm.triggerAlert('帳號未輸入')
        evt.preventDefault()
        doneCB()
        return
      }
      if (!this.popupAccountFormObj['password']) {
        this.$refs.merchantAccountQuickForm.triggerAlert('密碼未輸入')
        evt.preventDefault()
        doneCB()
        return
      }
      if (this.popupAccountFormObj['password'] !== this.popupAccountFormObj['password2']) {
        this.$refs.merchantAccountQuickForm.triggerAlert('兩次密碼不同')
        evt.preventDefault()
        doneCB()
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'updateStoreManageAccount',
        'merchant_store_id':this.popupAccountFormObj['id'],
        'account':this.popupAccountFormObj['account'],
        'password':this.popupAccountFormObj['password'],
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            //vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            vm.$refs.merchantAccountQuickForm.triggerAlert(data.msg)
            doneCB()
            return
          }
          // eslint-disable-next-line
          // 麻煩的是成功時要改parent的分店列表的account與店長姓名
          vm.parentRef.FilteredStores[vm.parentRef.popupAccountFormObj.row_index].account = vm.popupAccountFormObj.account
          vm.parentRef.FilteredStores[vm.parentRef.popupAccountFormObj.row_index].account_name = vm.popupAccountFormObj.account_name
          // filter所以連來源的Stores也要update...不能用index要跑迴圈
          for (let i=0;i<vm.parentRef.Stores.length;i++) {
            if (vm.parentRef.Stores[i].id === vm.popupAccountFormObj.id) {
              vm.parentRef.Stores[i].account = vm.popupAccountFormObj.account
              vm.parentRef.Stores[i].account_name = vm.popupAccountFormObj.account_name
              break
            }
          }
          vm.$bus.fnShowInfo('店長帳號建立成功')
          vm.cbCancel()
      },this)
    },
    async resetAdminPwd (doneCB,evt) {
      if (!this.popupAccountFormObj['password']) {
        this.$refs.merchantAccountQuickForm2.triggerAlert('密碼未輸入')
        evt.preventDefault()
        doneCB()
        return
      }
      if (this.popupAccountFormObj['password'] !== this.popupAccountFormObj['password2']) {
        this.$refs.merchantAccountQuickForm2.triggerAlert('兩次密碼不同')
        evt.preventDefault()
        doneCB()
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'updateStoreManageAccount',
        'merchant_store_id':this.popupAccountFormObj['id'],
        'account':"",
        'password':this.popupAccountFormObj['password'],
      }

      try {
        let result = await apiUpdateStoreManageAccount(Param)
        console.log(result)
        // 成功通知成功後關閉
        this.$bus.fnShowInfo('密碼重設成功')
        this.cbCancel()
      } catch (error) {
        console.log('error',error)
        this.$refs.merchantAccountQuickForm2.triggerAlert(error.response.data.msg)
        doneCB()
      }

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$refs.merchantAccountQuickForm2.triggerAlert(data.msg)
      //       doneCB()
      //       return
      //     }
      //     // 成功通知成功後關閉
      //     vm.$bus.fnShowInfo('密碼重設成功')
      //     vm.cbCancel()
      // },this)
    },
    resetAccountPwd (doneCB,evt) {
      if (!this.popupAccountFormObj['password']) {
        this.$refs.merchantAccountQuickForm3.triggerAlert('密碼未輸入')
        doneCB()
        evt.preventDefault()
        return
      }
      if (this.popupAccountFormObj['password'] !== this.popupAccountFormObj['password2']) {
        this.$refs.merchantAccountQuickForm3.triggerAlert('兩次密碼不同')
        doneCB()
        evt.preventDefault()
        return
      }
      let Param = {
        'module':'merchant',
        'method':'reset_account_pwd',
        'merchant_account_id':this.popupAccountFormObj['merchant_account_id'],
        'password':this.popupAccountFormObj['password'],
        'account_memo':'',
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$refs.merchantAccountQuickForm3.triggerAlert(data.msg)
            doneCB()
            return
          }
          // 成功通知成功後關閉
          vm.$bus.fnShowInfo('密碼重設成功')
          vm.cbCancel()
      },this)
    },
  },
  computed: {
    parentRef () {
      if (this.parentVue) {
        return this.parentVue
      }
      else {
        return this.$parent
      }
    },
    popupAccountFormObj () {
      return this.parentRef['popupAccountFormObj']?this.parentRef['popupAccountFormObj']:{'action':undefined}
    },
  },
  created() {
    
  },
  watch: {
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
